import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { BusinessuserService } from 'src/app/services/businessuser.service';

@Component({
  selector: 'app-accountoptions',
  templateUrl: './accountoptions.component.html',
  styleUrls: ['./accountoptions.component.scss']
})
export class AccountoptionsComponent implements OnInit {
  finishedLoading: boolean = false;
  dataSource: MatTableDataSource<any>;
  displayedColumns = ['number', 'ID', 'displayName', 'optionName', 'description', 'state', 'menu'];
  page = null;
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }


  constructor(
    private route: ActivatedRoute,
    private businessuserService: BusinessuserService) {
    this.route.params.subscribe(params => {
      this.businessuserService.getAccountOptionsForAccount(params['id']).subscribe((options: Array<any>) => {
        this.dataSource = new MatTableDataSource(options);
        this.finishedLoading = true;
      })
    })
  }

  ngOnInit(): void {
  }

}
